// Atalhos de período dos dashboards (os mesmos do app tifiregerencial).
// A API recebe as datas em dd/mm/yyyy.

function doisDigitos(n: number) {
  return String(n).padStart(2, '0');
}

export function paraBR(data: Date) {
  return `${doisDigitos(data.getDate())}/${doisDigitos(data.getMonth() + 1)}/${data.getFullYear()}`;
}

export type PresetPeriodo = 'hoje' | '7dias' | 'mes' | 'mesAnterior' | 'ano';

export const PRESETS: { id: PresetPeriodo; rotulo: string }[] = [
  { id: 'hoje', rotulo: 'Hoje' },
  { id: '7dias', rotulo: '7 dias' },
  { id: 'mes', rotulo: 'Este mês' },
  { id: 'mesAnterior', rotulo: 'Mês anterior' },
  { id: 'ano', rotulo: 'Este ano' }
];

export function periodoDoPreset(preset: PresetPeriodo, hoje = new Date()): { ini: string; fim: string } {
  const d = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  switch (preset) {
    case 'hoje':
      return { ini: paraBR(d), fim: paraBR(d) };
    case '7dias':
      return { ini: paraBR(new Date(d.getFullYear(), d.getMonth(), d.getDate() - 6)), fim: paraBR(d) };
    case 'mes':
      return {
        ini: paraBR(new Date(d.getFullYear(), d.getMonth(), 1)),
        fim: paraBR(new Date(d.getFullYear(), d.getMonth() + 1, 0))
      };
    case 'mesAnterior':
      return {
        ini: paraBR(new Date(d.getFullYear(), d.getMonth() - 1, 1)),
        fim: paraBR(new Date(d.getFullYear(), d.getMonth(), 0))
      };
    case 'ano':
      return { ini: paraBR(new Date(d.getFullYear(), 0, 1)), fim: paraBR(new Date(d.getFullYear(), 11, 31)) };
  }
}
